import { MuteButton as MuteButton$1 } from "../../../../../ui/mute-button/component.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/volume-high.js";
import ForwardRef$1 from "../../../../../icons/dist/react/minimal/volume-low.js";
import ForwardRef$2 from "../../../../../icons/dist/react/minimal/volume-off.js";
import { Button } from "../../../shared/components/buttons/button.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-live-audio/components/buttons/mute-button.tsx
/** @jsxImportSource react */
function MuteButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs(MuteButton$1, {
		render: /* @__PURE__ */ jsx(Button, {}),
		className: (state) => cn("media-mute-button", resolveClassName(className, state)),
		...props,
		children: [
			/* @__PURE__ */ jsx(ForwardRef$2, { className: cn("media-button-icon", "media-mute-button-off-icon") }),
			/* @__PURE__ */ jsx(ForwardRef$1, { className: cn("media-button-icon", "media-mute-button-low-icon") }),
			/* @__PURE__ */ jsx(ForwardRef, { className: cn("media-button-icon", "media-mute-button-high-icon") })
		]
	});
}
//#endregion
export { MuteButton };

//# sourceMappingURL=mute-button.js.map